import {Box, Flex, Image, Text} from '@chakra-ui/react';
import React from 'react';
import {colors} from 'theme';
import {LocalMapMdList} from 'types';

interface Props {
  location: LocalMapMdList;
  onClick: (id: string, building: string) => void;
}

export const LocationItem = ({location, onClick}: Props) => {
  return (
    <Flex
      onClick={() => onClick(location.id, location.building)}
      cursor="pointer"
      key={location.id}
      fontSize="14px"
      alignItems="center"
      _hover={{
        bg: colors.lightGray,
        borderRadius: '15px',
      }}
    >
      <Box boxSize="56px" alignContent="center" justifyContent="center">
        <Image src="/map/locationPoint.svg" boxSize="25px" alt="LocationPoint" />
      </Box>
      <Box>
        <Text key={location.building} fontWeight="semibold">
          {location.name} {location.building}
        </Text>
        <Text textColor="#9E9B98" fontWeight="normal" fontSize="13px">
          {location.parent_name}
        </Text>
      </Box>
    </Flex>
  );
};
